import { render, staticRenderFns } from "./DispatchList.vue?vue&type=template&id=2156cf82&scoped=true"
import script from "./DispatchList.vue?vue&type=script&lang=js"
export * from "./DispatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156cf82",
  null
  
)

export default component.exports